<template>
  <div class="faq-list">
    <h2>{{ title }}</h2>

    <div class="faq-list-items">
      <div
        v-for="(item, index) in items"
        :key="item.question"
        class="faq-list-item"
      >
        <button
          class="faq-list-question"
          type="button"
          :aria-controls="`faq-list-answer-${index}`"
          :aria-expanded="isItemOpened(index)"
          @click="toggleItem(index)"
        >
          <span class="faq-list-question-text">
            {{ item.question }}
          </span>
          <span class="faq-list-question-toggle">
            {{ isItemOpened(index) ? '−' : '+' }}
          </span>
        </button>

        <div
          v-if="isItemOpened(index)"
          :id="`faq-list-answer-${index}`"
          class="faq-list-answer"
        >
          {{ item.answer }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue'

export default {
  name: 'FaqList',
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  setup() {
    const openedItems = ref([])

    function isItemOpened(index) {
      return openedItems.value.includes(index)
    }

    function toggleItem(index) {
      if (isItemOpened(index)) {
        openedItems.value = openedItems.value.filter(item => item !== index)
        return
      }

      openedItems.value = [...openedItems.value, index]
    }

    return {
      isItemOpened,
      toggleItem
    }
  }
}
</script>

<style lang="scss" scoped>
.faq-list {
  margin-top: 100px;
  text-align: left;

  h2 {
    margin: 0 0 40px;
    font-size: 30px;
    line-height: 1.2;
    text-align: left;
    text-transform: none;
  }

  &-items {
    border-bottom: 1px solid var(--line);
  }

  &-item {
    border-top: 1px solid var(--line);

    &:first-child {
      border-top: 0;
    }
  }

  &-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
    padding: 23px 12px;
    border: 0;
    background: transparent;
    color: var(--font-1);
    font: inherit;
    text-align: left;
    cursor: pointer;

    &-text {
      font-size: 20px;
      line-height: 26px;
      font-weight: 500;
    }

    &-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 24px;
      width: 24px;
      height: 24px;
      color: var(--font-2);
      font-size: 28px;
      line-height: 1;
      font-weight: 700;
    }
  }

  &-answer {
    padding: 0 56px 23px 12px;
    color: var(--font-3);
    font-size: 16px;
    line-height: 24px;
  }
}

@media screen and (max-width: 480px) {
  .faq-list {
    h2 {
      margin-bottom: 20px;
      font-size: 24px;
    }

    &-question {
      padding: 22px 0;

      &-text {
        font-size: 18px;
      }
    }

    &-answer {
      padding: 0 34px 24px 0;
      font-size: 16px;
    }
  }
}
</style>
